import { FC } from 'react';
import Spinner from '../../loading/spinner';

const SimpleButtonContainerContent: FC<{
  dropdownLabel: string;
  additionalContainerStyling?: string;
  isLoading?: boolean;
  widthClass?: string;
}> = ({
  dropdownLabel,
  additionalContainerStyling = '',
  isLoading = false,
  widthClass = ''
}) => {
  const defaultParentStyling = widthClass
    ? 'flex text-sm items-center py-2.5 px-3 justify-between'
    : 'flex text-sm items-center py-2.5 px-3 justify-center';

  return (
    <>
      <div
        className={`${defaultParentStyling} ${additionalContainerStyling} ${widthClass}`}
      >
        {isLoading ? (
          <div className="absolute left-1/2 -translate-x-1/2">
            <Spinner></Spinner>
          </div>
        ) : null}
        <p className={`pr-2 text-center ${isLoading ? 'invisible' : ''}`}>
          {dropdownLabel}
        </p>
        <i
          className={`ra-icons-generic-down-arrow text-bottom text-xs flex ${
            isLoading ? 'invisible' : ''
          }`}
        ></i>
      </div>
    </>
  );
};

export default SimpleButtonContainerContent;
